/**
 * Global error handler to catch and log JavaScript errors
 * This helps prevent blank screens and provides better debugging
 */

// Store original console.error to avoid infinite loops
const originalConsoleError = console.error;

// Global error handler for unhandled JavaScript errors
window.addEventListener('error', (event) => {
  console.error('Global JavaScript Error:', {
    message: event.error?.message || event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack,
    error: event.error
  });

  // Special handling for getServiceIcon error
  if (event.error?.message?.includes('getServiceIcon is not defined')) {
    console.error('getServiceIcon error detected - this might be a timing or import issue');
    
    // Try to provide a fallback
    if (typeof window !== 'undefined' && !(window as any).getServiceIcon) {
      (window as any).getServiceIcon = (type: string) => {
        return null; // Return null instead of crashing
      };
    }
  }
});

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Global Promise Rejection:', {
    reason: event.reason,
    promise: event.promise
  });
});

// Enhanced console.error to catch React errors
console.error = (...args) => {
  originalConsoleError(...args);

  // Log React errors with more context
  if (args[0] && typeof args[0] === 'string' && args[0].includes('React')) {
    originalConsoleError('React Error Context:', {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
      args: args
    });
  }
};

export const initializeGlobalErrorHandling = () => {
};